import { UserLocaleEnum } from 'collections/users';

export const localeLabels: Record<UserLocaleEnum, string> = {
  [UserLocaleEnum.Cs]: 'Czech',
  [UserLocaleEnum.Da]: 'Danish',
  [UserLocaleEnum.De]: 'German',
  [UserLocaleEnum.En]: 'English',
  [UserLocaleEnum.Es]: 'Spanish',
  [UserLocaleEnum.Fi]: 'Finnish',
  [UserLocaleEnum.Fr]: 'French',
  [UserLocaleEnum.It]: 'Italian',
  [UserLocaleEnum.Nb]: 'Norwegian Bokmål',
  [UserLocaleEnum.Nl]: 'Dutch',
  [UserLocaleEnum.Pl]: 'Polish',
  [UserLocaleEnum.Pt]: 'Portuguese',
  [UserLocaleEnum.Sv]: 'Swedish',
  [UserLocaleEnum.Tr]: 'Turkish',
  [UserLocaleEnum.Hi]: 'Hindi',
  [UserLocaleEnum.Ru]: 'Russian',
  [UserLocaleEnum.Uk]: 'Ukrainian',
  [UserLocaleEnum.Zh]: 'Chinese',
};

export const localeOptions = Object.values(UserLocaleEnum).map((locale) => ({
  label: localeLabels[locale],
  value: locale,
}));
